<template>
  <div class="loading" id="loading" v-show="show.value">
    <div class="load_box">
      <Loading color="#666" size="40px" class="van-loading-box" />
      <span>{{ message.value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref } from 'vue'
import { Loading } from 'vant'

defineProps<{
  show: Ref<boolean>
  message: Ref<string>
}>()
</script>

<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.6);

  .load_box {
    background-color: #fff;
    width: 140px;
    height: 140px;
    border-radius: 8px;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.8px;
    font-size: 14px;

    .van-loading-box {
      margin-bottom: 10px;
    }
  }
}
</style>
